// extracted by mini-css-extract-plugin
export default {"logoWrapper":"logoWrapperStyles_logoWrapper__yktbJ"};